// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__13CCl","list":"BalanceDue_list__2zwHL","listRow":"BalanceDue_listRow__2wNoV","total":"BalanceDue_total__3HC6i"};